
export function getUniqueCharacters(texts: string[]): Set<string> {
    const allChars = new Set<string>();
    for (const item of texts) {
        if (item) {
            for (const char of item) {
                allChars.add(char);
            }
        }
    }
    return allChars;
}
